import React from 'react';
import PropTypes from 'prop-types';

class Provider extends React.Component {
    getChildContext() {
        return {
            locale: this.props.locale
        };
    }

    render() {
        return this.props.children;
    }
}

Provider.childContextTypes = {
    locale: PropTypes.string,
    children: PropTypes.any
};

Provider.propTypes = {
    locale: PropTypes.string,
    children: PropTypes.any
};

const connect = (Component) => {
    function Wrapper(props, { locale }) {
        return (
            <Component i18n={i18n.spawn(locale || 'en-US')} {...props}/>
        );
    }

    Wrapper.contextTypes = {
        locale: PropTypes.string
    };

    Wrapper.displayName = `I18nProviderHoc(${Component.displayName || Component.name || 'Component'})`;

    return Wrapper;
};

export { Provider, connect };
